<template>
    <div class="coming-soon">
        <div class="coming-soon__card">
            <span class="coming-soon__glyph">
                <i :class="['pi', `pi-${icon}`]" aria-hidden="true" />
            </span>
            <h1 class="coming-soon__title">{{ title }}</h1>
            <p class="coming-soon__blurb">{{ blurb }}</p>
            <span class="coming-soon__mark">Coming soon</span>
        </div>
    </div>
</template>

<script setup>
// The one placeholder behind every "Coming Soon" page in the Auction
// Operations context. The design's shape is shown — its sections and pages —
// and this is what says, in the page's own words, why nothing is behind it
// yet. One component, a title and a blurb per page from lib/contexts.js.
defineOptions({ name: 'ComingSoonView' })

defineProps({
    title: { type: String, required: true },
    // A PrimeIcons name, the same one the nav row shows.
    icon: { type: String, default: 'th-large' },
    blurb: { type: String, default: 'This page is part of the planned experience and has not been designed yet.' }
})
</script>

<style scoped>
.coming-soon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
}

.coming-soon__card {
    width: 100%;
    max-width: 640px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 56px 48px;
    border: 1px dashed var(--p-content-border-color);
    border-radius: 16px;
    background: var(--p-content-background);
}

.coming-soon__glyph {
    width: 56px;
    height: 56px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    background: var(--p-highlight-background);
    color: var(--p-primary-500);
    font-size: 24px;
}

.coming-soon__title {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--p-text-color);
}

.coming-soon__blurb {
    max-width: 440px;
    margin: 12px 0 0;
    font-size: 15px;
    line-height: 1.55;
    color: var(--p-text-muted-color);
}

.coming-soon__mark {
    margin-top: 24px;
    padding: 5px 11px;
    border: 1px solid var(--p-content-border-color);
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--p-surface-400);
}
</style>
